import { Box, LinearProgress } from "@mui/material";

export interface UploadProgressBarProps {
    isUploading: boolean;
    uploadPercentage: number | undefined;
}

function UploadProgressBar(props: UploadProgressBarProps) {
    if (!props.isUploading) {
        return null;
    }

    // Separate keys make React mount a new bar when the first progress arrives. Reusing the indeterminate bar's element
    // would let MUI's transform transition animate it from full width down to the first percentage.
    // Progress arrives about every 100 ms. Each new value restarted MUI's 0.4 s transition, so the drawn bar fell far
    // behind the real progress; a transition shorter than the update interval keeps up and still moves smoothly.
    return (
        <Box sx={{ marginTop: 2 }}>
            {props.uploadPercentage === undefined ? (
                <LinearProgress key="indeterminate" sx={{ height: 10, borderRadius: 5 }} />
            ) : (
                <LinearProgress
                    key="determinate"
                    sx={{ height: 10, borderRadius: 5, "& .MuiLinearProgress-bar": { transition: "transform 0.1s linear" } }}
                    variant="determinate"
                    value={props.uploadPercentage}
                />
            )}
        </Box>
    );
}

export default UploadProgressBar;
